import { FC, useMemo } from 'react';
import styled from '@emotion/styled';
import { UserAccount } from 'api/account/account.types';
import { Text } from 'components/core/text';
import { mediaDesktop, mediaMobile } from 'components/core/theme/breakpoints';
import { Link } from 'react-router-dom';

import { Logo } from './Styles';

export const BendLogoSvg = ({
  primary = '#02A0A0',
  secondary = '#2EC060',
}: {
  primary?: string;
  secondary?: string;
}) => {
  return (
    <svg viewBox="0 0 115 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.27273 3.13636C6.27273 1.4042 4.86853 0 3.13636 0C1.4042 0 0 1.4042 0 3.13636V24.0455C0 31.5515 6.08486 37.6364 13.5909 37.6364C21.097 37.6364 27.1818 31.5515 27.1818 24.0455C27.1818 16.5394 21.097 10.4545 13.5909 10.4545C11.8587 10.4545 10.4545 11.8587 10.4545 13.5909C10.4545 15.3231 11.8587 16.7273 13.5909 16.7273C17.6326 16.7273 20.9091 20.0037 20.9091 24.0455C20.9091 28.0872 17.6326 31.3636 13.5909 31.3636C9.54919 31.3636 6.27273 28.0872 6.27273 24.0455V3.13636Z"
        fill="url(#paint0_linear_263_347)"
      />
      <path
        d="M111.864 0C110.131 0 108.727 1.4042 108.727 3.13636V24.0455C108.727 28.0872 105.451 31.3636 101.409 31.3636C97.3674 31.3636 94.0909 28.0872 94.0909 24.0455C94.0909 20.0037 97.3674 16.7273 101.409 16.7273C103.141 16.7273 104.545 15.3231 104.545 13.5909C104.545 11.8587 103.141 10.4545 101.409 10.4545C93.903 10.4545 87.8182 16.5394 87.8182 24.0455C87.8182 31.5515 93.903 37.6364 101.409 37.6364C108.915 37.6364 115 31.5515 115 24.0455V3.13636C115 1.4042 113.596 0 111.864 0Z"
        fill="url(#paint1_linear_263_347)"
      />
      <path
        d="M71.0909 16.7273C69.1355 16.7273 67.3651 17.49 66.0499 18.7404C64.6433 20.0775 63.7727 21.9572 63.7727 24.0455V34.5C63.7727 36.2322 62.3685 37.6364 60.6364 37.6364C58.9042 37.6364 57.5 36.2322 57.5 34.5V24.0455C57.5 20.1683 59.1276 16.6662 61.7279 14.1942C64.1625 11.8797 67.4636 10.4545 71.0909 10.4545C78.597 10.4545 84.6818 16.5394 84.6818 24.0455V34.5C84.6818 36.2322 83.2776 37.6364 81.5455 37.6364C79.8133 37.6364 78.4091 36.2322 78.4091 34.5V24.0455C78.4091 20.0037 75.1326 16.7273 71.0909 16.7273Z"
        fill="url(#paint2_linear_263_347)"
      />
      <path
        d="M48.5473 29.7074L48.55 29.7107C49.091 29.2672 49.7831 29.001 50.5373 29.001C52.2694 29.001 53.6736 30.4051 53.6736 32.1373C53.6736 33.1834 53.1615 34.1098 52.3744 34.6796C47.0386 38.9379 39.2398 38.5966 34.2989 33.6557C28.9913 28.3481 28.9913 19.7428 34.2989 14.4352C39.5744 9.15973 48.1074 9.12783 53.4228 14.3396C54.7101 15.6019 54.7189 17.6712 53.4454 18.9446L46.8587 25.5314C45.6338 26.7562 43.648 26.7562 42.4232 25.5314C41.1983 24.3066 41.1983 22.3207 42.4232 21.0959L46.3683 17.1508C43.789 16.2329 40.7981 16.8069 38.7344 18.8707C35.8764 21.7286 35.8764 26.3623 38.7344 29.2202C41.4196 31.9054 45.6726 32.068 48.5473 29.7074Z"
        fill="url(#paint3_linear_263_347)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_263_347"
          x1="6.60459e-07"
          y1="18.8143"
          x2="115"
          y2="18.8143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_263_347"
          x1="6.60459e-07"
          y1="18.8143"
          x2="115"
          y2="18.8143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_263_347"
          x1="6.60459e-07"
          y1="18.8143"
          x2="115"
          y2="18.8143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
        <linearGradient
          id="paint3_linear_263_347"
          x1="6.60459e-07"
          y1="18.8143"
          x2="115"
          y2="18.8143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LogoWrapper = styled.div`
  width: 115px;

  ${mediaMobile} {
    width: 75px;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 1px 0px 0px rgba(211, 210, 206, 1);

  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;

  height: 50px;
  padding: 0 16px;

  ${mediaDesktop} {
    height: 90px;
    padding: 20px 32px;
  }
`;

const NameCircleWrapper = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 25px;
  background-color: #e9d4f2;

  ${mediaDesktop} {
    width: 50px;
    height: 50px;
  }
`;

interface NCProps {
  user?: UserAccount | null;
}

export const NameCircle: FC<NCProps> = ({ user }) => {
  const name = useMemo(() => {
    if (!user) return '';
    return `${user.firstName?.[0] ?? ''}${user.lastName?.[0] ?? ''}`;
  }, [user]);

  return (
    <NameCircleWrapper to="/settings">
      <Text bold block className="self-center">
        {name}
      </Text>
    </NameCircleWrapper>
  );
};

interface Props {
  user: UserAccount | null | undefined;
  isMobileView?: boolean;
  showNavigation?: boolean;
  hideBoxShadow?: boolean;
}

export const GlobalHeader: FC<Props> = ({ user, hideBoxShadow }) => {
  const shadow = hideBoxShadow ? 'none' : '0px 1px 0px 0px rgba(211, 210, 206, 1)';
  return (
    <Wrapper style={{ boxShadow: shadow }}>
      <Logo className="cursor-pointer flex items-center">
        <Link to="/">
          <LogoWrapper>
            <BendLogoSvg />
          </LogoWrapper>
        </Link>
      </Logo>
      <NameCircle user={user} />
    </Wrapper>
  );
};
